import { Component } from "react";
import { AlertTriangle } from "lucide-react";

/* Gate 2D — minimal centralized crash containment. A render-time exception anywhere in the
 * routed app is caught here so the operator sees a controlled recovery UI instead of a blank
 * screen. Router + AuthProvider stay mounted (this wraps <Routes>), so navigation recovery works. */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Existing console logging only — no Sentry/telemetry (Gate 2D locked).
    console.error("Render error captured by ErrorBoundary:", error, info);
  }

  handleRetry = () => this.setState({ hasError: false });
  handleReload = () => window.location.reload();
  handleHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            padding: "2rem",
            textAlign: "center",
            background: "#0f172a",
            color: "#e2e8f0",
          }}
        >
          <AlertTriangle size={48} color="#f59e0b" aria-hidden="true" />
          <h1 style={{ fontSize: "1.5rem", fontWeight: 700, margin: 0 }}>
            Halaman gagal dimuat
          </h1>
          <p style={{ maxWidth: "28rem", color: "#94a3b8", margin: 0 }}>
            Terjadi kesalahan saat menampilkan halaman ini. Data Anda aman — silakan coba lagi
            atau muat ulang halaman.
          </p>
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", justifyContent: "center" }}>
            <button
              data-testid="error-retry-btn"
              onClick={this.handleRetry}
              style={btn("#2563eb")}
            >
              Coba Lagi
            </button>
            <button
              data-testid="error-reload-btn"
              onClick={this.handleReload}
              style={btn("#334155")}
            >
              Muat Ulang
            </button>
            <button
              data-testid="error-home-btn"
              onClick={this.handleHome}
              style={btn("#334155")}
            >
              Kembali ke Beranda
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function btn(bg) {
  return {
    background: bg,
    color: "#fff",
    border: "none",
    borderRadius: "0.5rem",
    padding: "0.6rem 1.2rem",
    fontWeight: 600,
    cursor: "pointer",
  };
}

export default ErrorBoundary;
